import React from 'react';

/**
 * PageHeader - Reusable page header component for consistent styling
 * 
 * @param {string} title - Main page title
 * @param {string} description - Page description/subtitle
 * @param {React.ReactNode} actions - Optional action buttons (right side)
 * @param {React.ReactNode} icon - Optional icon component
 */
const PageHeader = ({ title, description, actions, icon: Icon }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {Icon && (
            <div className="p-3 bg-gradient-to-r from-brand to-brand-dark rounded-xl">
              <Icon className="w-6 h-6 text-white" />
            </div>
          )}
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {description && (
              <p className="text-sm text-gray-600 mt-1">{description}</p>
            )}
          </div>
        </div>
        {actions && (
          <div className="flex items-center gap-3">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
